import { getStaticFiltersForDynamicApi } from '@mfs/client/listings-client/components/Filters/helpers'
import PCLNAnalytics from '@pcln/analytics'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { buildDynamicFilterRequest } from '../DynamicFilters/buildDynamicFilterRequest'
import { getDynamicFilterChips } from '../DynamicFilters/DynamicFiltersAPI'

export const useDynamicFiltersData = ({ searchRequest, activeTabId, pclnBootstrapData }) => {
  const [chips, setChips] = useState([])
  const skipPclnGraph = pclnBootstrapData?.features?.flights?.skipPclnGraph

  const latestFilterState = useSelector((state) => ({
    numStops: state?.stopsFilter || [],
    airlineCodes: state?.airlinesFilter || [],
    attributes: state?.attributesFilter || [],
    originAirportCodes: state?.airportsFilter?.[0]?.originAirports || [],
    destAirportCodes: state?.airportsFilter?.[0]?.destinationAirports || [],
    arrivalTimeOptions: state?.timeFilter?.[0]?.categories?.[0]?.landing?.timebands || [],
    departTimeOptions: state?.timeFilter?.[0]?.categories?.[0]?.takeoff?.timebands || [],
  }))

  const staticFilters = useMemo(() => {
    /**
     * Removing CHANGES from Dynamic Filters since it's not a supported enum value for the API
     */
    const filterState = {
      ...latestFilterState,
      attributes: latestFilterState.attributes.filter((attribute) => attribute.value !== 'CHANGES'),
    }
    return getStaticFiltersForDynamicApi({ latestFilterState: filterState })
  }, [latestFilterState])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const request = buildDynamicFilterRequest({ searchRequest, activeTabId, staticFilters })
        const response = await getDynamicFilterChips({ request, skipPclnGraph })
        setChips(response)
      } catch (e) {
        PCLNAnalytics.logError({ api: 'Dynamic Filters', e })
      }
    }
    fetchData()
  }, [activeTabId]) // re-fetch if the active tab (slice) changes

  return { chips }
}
